import { ChangeEventHandler } from 'react'

interface CateringInputProps {
  cateringNeeds: string
  onChange: ChangeEventHandler<HTMLTextAreaElement>
}

const CateringInput = ({ cateringNeeds, onChange }: CateringInputProps): JSX.Element => (
  <div className='flex flex-col gap-2'>
    <p className='!font-bold text-sm sm:text-base text-black leading-6'>
      Do you have any catering requirements?
    </p>
    <label htmlFor='catering-needs' className='visually-hidden'>
      Catering Requirement Notes (optional step)
    </label>
    <textarea
      id='catering-needs'
      rows={5}
      value={cateringNeeds}
      onChange={onChange}
      placeholder='If you have any food and drink requests or other requirements, please write them here.'
      className={`w-full bg-white border border-[#bfbfbf] rounded-[4px] px-[10px] py-2
        text-sm sm:text-base text-[#1f1f1f] leading-6 outline-none resize-none
        focus:border-[#595959] transition-colors`}
    />
  </div>
)

export default CateringInput
